// extracted by mini-css-extract-plugin
module.exports = {"items_section":"withsocialiconsvariation_items_section___V4AY","item":"withsocialiconsvariation_item__2HIgO","image":"withsocialiconsvariation_image__mCmGn"};